import styles from './M_SocialInput.module.css';
import A_SocialInput from '@/components/A_Atoms/A_SocialInput/A_SocialInput';
import A_CircleButton from '@/components/A_Atoms/A_CircleButton/A_CircleButton';
import { Q_Icon } from '@/components/Q_Quarks/Q_Icon/Q_Icon';

interface M_SocialInputProps {
  value: string;
  onChange: (value: string) => void;
  isFirst?: boolean;
  showSaveButton?: boolean;
  showDeleteButton?: boolean;
  isSaved?: boolean;
  originalValue?: string;
  platformIcon?: string;
  onSave?: () => void;
  onDelete?: () => void;
}

export default function M_SocialInput({
  value,
  onChange,
  isFirst = false,
  showSaveButton = false,
  showDeleteButton = false,
  isSaved = false,
  originalValue,
  platformIcon,
  onSave,
  onDelete,
}: M_SocialInputProps) {
  const handleCopyLink = async () => {
    const linkToCopy = originalValue || value;
    if (!linkToCopy) return;

    try {
      await navigator.clipboard.writeText(linkToCopy);
    } catch (err) {
      const textArea = document.createElement('textarea');
      textArea.value = linkToCopy;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
    }
  };

  const handleOpenLink = () => {
    const linkToOpen = originalValue || value;
    if (!linkToOpen) return;

    window.open(linkToOpen, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className={styles.wrapper}>
      <A_SocialInput
        value={value}
        onChange={onChange}
        platformIcon={platformIcon}
      />
      {isSaved && value && (
        <>
          <A_CircleButton
            icon={<Q_Icon.CopyIcon width={24} height={24} fill='none' />}
            variant='secondary'
            onClick={handleCopyLink}
          />
          <A_CircleButton
            icon={
              <Q_Icon.ExternalLinkIcon width={24} height={24} fill='none' />
            }
            variant='secondary'
            onClick={handleOpenLink}
          />
        </>
      )}
      {showSaveButton && value && onSave && (
        <A_CircleButton
          icon={<Q_Icon.CheckmarkIcon width={24} height={24} fill='none' />}
          variant='primary'
          onClick={onSave}
        />
      )}
      {showDeleteButton && onDelete && (
        <A_CircleButton
          icon={<Q_Icon.CrossIcon width={24} height={24} fill='none' />}
          variant='secondary'
          onClick={onDelete}
        />
      )}
    </div>
  );
}
